exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#beacon-container {\n  display: none !important;\n}\n.navbar-guide {\n  bottom: -200px;\n  transition: bottom 0.3s;\n}\n.navbar-guide.show {\n  bottom: 0;\n}", ""]);

// exports
